import { render, staticRenderFns } from "./DialogForm.vue?vue&type=template&id=3bbaf394&scoped=true"
import script from "./DialogForm.vue?vue&type=script&lang=js"
export * from "./DialogForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbaf394",
  null
  
)

export default component.exports